// @ts-check

import { BorderedPanel, PageHead, PageHeader } from "~/components/Shared/PageParts";
import QuickLinksButton from "~/components/Dashboard/QuickLinksButton";

export default function DashboardHeader() {
    const greetingText = getGreetingText();

    return (
        <PageHead style={{marginBottom: "1rem"}}>
            <BorderedPanel noPadding>
                <PageHeader
                    title={greetingText}
                    subTitle="Here's what's going on today..."
                    action={<QuickLinksButton />}
                />
            </BorderedPanel>
        </PageHead>
    )
}

function getGreetingText() {
    const h = new Date().getHours();
    if (h < 12) {
        return "Good morning";
    } else if (h < 18) {
        return "Good afternoon";
    } else {
        return "Good evening";
    }
}